import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasLevel, ladderAccess } from '@church/data'
import {
  InboxPanel,
  MessagesPanel,
  MessagingSettingsPanel,
  WorkflowsPanel,
} from '../components/messaging/MessagingPanels.tsx'
import { PageHeader, Tabs } from '../components/ui.tsx'
import { useTabParam } from '../lib/tabs.ts'

/** Communications: messages and their results, the text inbox, workflows, settings. */
export const Route = createFileRoute('/_authed/_shell/messages/')({
  beforeLoad: ({ context }) => {
    if (!hasLevel(ladderAccess(context.me), 'messages', 'viewer')) throw redirect({ to: '/' })
  },
  component: MessagesScreen,
})

const TABS = ['Messages', 'Texts', 'Workflows', 'Settings'] as const
type Tab = (typeof TABS)[number]

function MessagesScreen() {
  const [tab, setTab] = useTabParam<Tab>(TABS)
  return (
    <div className="space-y-6">
      <PageHeader title="Messages" />
      <Tabs tabs={TABS} value={tab} onChange={setTab}>
        {tab === 'Messages' && <MessagesPanel />}
        {tab === 'Texts' && <InboxPanel />}
        {tab === 'Workflows' && <WorkflowsPanel />}
        {tab === 'Settings' && <MessagingSettingsPanel />}
      </Tabs>
    </div>
  )
}
